import { useClientsStore } from '@/store/clients';
import { useInvoicesStore } from '@/store/invoices';
import { useCompanyStore } from '@/store/companies';
import { usePaymentStore } from '@/store/payments';
import { useTaxStore } from '@/store/taxes';
import { useTemplateStore } from '@/store/templates';
import { useNotificationsStore } from '@/store/notifications';
import { useDeviceStore } from '@/store/devices';
import { useSubscriptionStore } from '@/store/subscription';

export function resetAllStores() {
  return new Promise((resolve) => {
    useSubscriptionStore().reset();
    useClientsStore().reset();
    useInvoicesStore().reset();
    useCompanyStore().reset();
    usePaymentStore().reset();
    useTaxStore().reset();
    useTemplateStore().reset();
    useNotificationsStore().reset();
    useDeviceStore().reset();
    resolve(); // let the caller know we're done
  });
}
